/**
 * Internal dependencies
 */
import {
    CURRENT_BARCODE_LOOKUP_RECEIVE,
    CURRENT_BARCODE_LOOKUP_REQUEST,
    CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS,
    CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import {getCurrentBarcodeLookup, requestingCurrentBarcodeLookup} from 'state/current-barcode-lookup/selectors';

/**
 * [description]
 *
 * @param  {[type]}         [description]
 * @return {[type]}         [description]
 */
export const setCurrentBarcodeLookup = (barcodelookup) => {
    return {
        type: CURRENT_BARCODE_LOOKUP_RECEIVE,
    };
};

/**
 * [description]
 *
 * @param  {[type]} ) [description]
 * @return {[type]}   [description]
 */
export const requestCurrentBarcodeLookup = () => (dispatch) => {
    dispatch({
        type: CURRENT_BARCODE_LOOKUP_REQUEST,
    });

    return cscom
        .currentBarcodeLookup()
        .get()
        .then((barcodelookup) => {
            dispatch({
                type: CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS,
            });
            dispatch({
                type: CURRENT_BARCODE_LOOKUP_RECEIVE,
                payload: {
                    barcodelookup,
                },
            });

            return barcodelookup;
        })
        .catch((error) => {
            if (error == 'Error: Not Found') {
                dispatch({
                    type: CURRENT_BARCODE_LOOKUP_REQUEST_SUCCESS,
                });
                return;
            }
            dispatch({
                type: CURRENT_BARCODE_LOOKUP_REQUEST_FAILURE,
                error,
            });
        });
};

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestCurrentBarcodeLookupIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const currentBarcodeLookup = getCurrentBarcodeLookup(getState());
    const requesting = requestingCurrentBarcodeLookup(getState());

    if (!currentBarcodeLookup && requesting == false) {
        return dispatch(requestCurrentBarcodeLookup(...props));
    }

    return currentBarcodeLookup;
}
